(function () {
  'use strict';

  angular
    .module('productivity-indicators', [
      'ui.router'
    ]);
}());
